import script from "./chatGpt.vue?vue&type=script&setup=true&lang=js"
export * from "./chatGpt.vue?vue&type=script&setup=true&lang=js"

import "./chatGpt.vue?vue&type=style&index=0&id=06a436be&lang=less&scoped=true"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06a436be"]])

export default __exports__